<script lang="ts" setup>
  import { useComponentConfig } from '@/shared/lib/tenant'

  defineProps<{
    price: string | number
  }>()

  const { componentsConfig } = useComponentConfig()
  const coinIcon = computed(() => componentsConfig.value?.badge?.coinIcon)
</script>

<template>
  <div class="ease flex items-center justify-start gap-0.5 transition-all duration-200">
    <span class="body-lg-bold">{{ price }}</span>
    <img
      :src="coinIcon"
      alt="coin"
      width="14"
      height="14"
    />
  </div>
</template>
